import BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import ImageSkeleton from "./ImageSkeleton";

const Construction = () => {
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);

  const runOnStart = async () => {
    setLoading(true);
    await axios
      .get(`${BASE_URL}/construct/get-all-construction`)
      .then((response) => setProjects([...response.data.data]))
      .catch(() => {});
    setLoading(false);
  };

  useEffect(() => { runOnStart(); }, []);

  return (
    <div className="font-Montserrat min-h-screen bg-gray-50">
      {/* Page top spacer for fixed navbar */}
      <div className="h-[56px] md:h-[72px]" />

      {/* Page header */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-6xl mx-auto px-4 md:px-10 py-10 md:py-16 text-center">
          <p className="text-[#1877F2] uppercase tracking-[0.3em] text-xs md:text-sm font-semibold mb-3">
            Our Work
          </p>
          <h1 className="text-2xl md:text-4xl font-bold text-gray-900 mb-3">
            Construction Portfolio
          </h1>
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
            A showcase of our ongoing and completed construction projects across Nigeria.
            Click any project to view the full gallery.
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 md:px-10 py-10 md:py-16">
        {loading ? (
          <ImageSkeleton />
        ) : projects.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {projects.map((project, index) => (
              <Link
                to={`/pictures/${project._id}`}
                key={index}
                className="group block bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300"
              >
                {/* Cover image with hover overlay */}
                <div className="relative overflow-hidden h-56 md:h-64 flex-shrink-0">
                  <img
                    src={project.coverPhoto}
                    alt={project.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-300 flex items-center justify-center">
                    <span className="text-white font-semibold text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-[#1877F2] px-5 py-2.5 rounded-full">
                      View Gallery →
                    </span>
                  </div>
                </div>

                {/* Status badge */}
                {project.status && (
                  <div className="absolute top-3 left-3">
                    <span className={`text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wide ${
                      project.status === "Completed"
                        ? "bg-green-500 text-white"
                        : "bg-[#1877F2] text-white"
                    }`}>
                      {project.status}
                    </span>
                  </div>
                )}

                {/* Card body */}
                <div className="p-5">
                  <div className="w-6 h-0.5 bg-[#1877F2] rounded-full mb-3" />
                  <h3 className="font-bold text-gray-900 text-base leading-snug group-hover:text-[#1877F2] transition-colors duration-200">
                    {project.title}
                  </h3>
                  {project.description && (
                    <p className="text-gray-500 text-xs mt-1.5 line-clamp-2">{project.description}</p>
                  )}
                  <div className="flex items-center gap-3 mt-2 flex-wrap">
                    {project.location && (
                      <span className="text-gray-400 text-xs flex items-center gap-1">📍 {project.location}</span>
                    )}
                    {project.year && (
                      <span className="text-gray-400 text-xs">📅 {project.year}</span>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="text-center py-24">
            <p className="text-4xl mb-4">🏗️</p>
            <p className="text-gray-400 text-lg font-medium">No projects to display yet.</p>
            <p className="text-gray-300 text-sm mt-2">Check back soon — we're always building.</p>
          </div>
        )}
      </div>

      {/* CTA strip */}
      <div className="bg-[#1877F2] py-12 text-center text-white">
        <h2 className="text-xl md:text-2xl font-bold mb-2">Want us to build for you?</h2>
        <p className="text-white/80 text-sm mb-6">
          Contact us today and let's turn your dream home into a reality.
        </p>
        <a
          href="https://wa.me/+2349033020343"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-white text-[#1877F2] font-bold py-3 px-8 rounded-full hover:bg-gray-100 transition-colors duration-200 text-sm"
        >
          Chat on WhatsApp
        </a>
      </div>
    </div>
  );
};

export default Construction;
